<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: "app",
    created () {
      this.initPage()
      addEventListener('resize', () => {
        this.initPage()
      })
    },
    methods: {
      initPage () {
        this.$store.commit('setContentWidth',window.innerWidth)
        this.$store.commit('setContentHeith',window.innerHeight)
      }
    }
  }
</script>

<style>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html, body{
  width:100%;
  height: 100%;
  overflow: hidden;
}
*, :after, :before {
  box-sizing: border-box;
}
#app {
  width:100%;
  height: 100%;
  margin:0;
  padding:0;
}
.ivu-page-options-sizer{
  position: relative;
}
@font-face {
  font-family: 'iconfont';  /* project id 1253004 */
  src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot');
  src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff') format('woff'),
  url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.svg#iconfont') format('svg');
}

.iconfont{
  font-family:"iconfont" !important;
  font-size:14px;font-style:normal;
  padding-right: 5px;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>
